import type { SVGProps } from 'react'

export const DownTwo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320' {...props}>
    <path d='M0,256L34.3,240C68.6,224,137,192,206,165.3C274.3,139,343,117,411,128C480,139,549,181,617,192C685.7,203,754,181,823,170.7C891.4,160,960,160,1029,176C1097.1,192,1166,224,1234,218.7C1302.9,213,1371,171,1406,149.3L1440,128L1440,0L1405.7,0C1371.4,0,1303,0,1234,0C1165.7,0,1097,0,1029,0C960,0,891,0,823,0C754.3,0,686,0,617,0C548.6,0,480,0,411,0C342.9,0,274,0,206,0C137.1,0,69,0,34,0L0,0Z'></path>
  </svg>
)

DownTwo.toString = () => 'down2'
